export default __webpack_public_path__ + "static/media/G-4.78d0aa68.svg";